import {
  castArray,
  find,
  flatMap,
  isArray,
  isEmpty,
  isObject,
  isString,
  map,
  mapValues,
  values,
} from 'es-toolkit/compat';

export const catchMultipleEmbeddedBrackets = /(?<=^|[^>])(<\S.+?>)(?=$|[^<])/gm;

export const getAllBracketsFromString = (stringToGetBracketsFrom: string): string[] => {
  const matches = Array.from(stringToGetBracketsFrom.matchAll(catchMultipleEmbeddedBrackets));
  return map(matches, ([matchString]: any = []) => matchString);
};

const recursiveGetBracketsFromValue = (value: any): string[] => {
  if (isString(value) || isArray(value)) {
    return flatMap(castArray(value), (item): string[] => {
      if (isString(item) && !isEmpty(item)) {
        return getAllBracketsFromString(item);
      }

      if (isObject(item)) {
        return recursiveGetBracketsFromObject(item);
      }

      return [];
    });
  }

  if (isObject(value)) {
    return recursiveGetBracketsFromObject(value);
  }

  return [];
};

export const recursiveGetBracketsFromObject = (featuresSyntax: Record<string, any>): string[] => {
  return flatMap(values(featuresSyntax), recursiveGetBracketsFromValue);
};

export const stringReplaceBracketsWithDisplayNames = (
  stringToReplace: any,
  parsedBrackets: { key: string; displayName: string }[]
) => {
  if (!isString(stringToReplace) || isEmpty(stringToReplace)) {
    return stringToReplace;
  }
  return stringToReplace.replace(
    catchMultipleEmbeddedBrackets,
    (match) => find(parsedBrackets, { key: match })?.displayName || match
  );
};

export const recursiveReplaceFeaturesSyntaxWithDisplayNames = (
  featuresSyntax: Record<string, any>,
  parsedBrackets: { key: string; displayName: string }[]
): Record<string, any> => {
  const replaceValue = (value: any): any => {
    if (isString(value)) {
      return stringReplaceBracketsWithDisplayNames(value, parsedBrackets);
    }

    if (isArray(value)) {
      return map(value, replaceValue);
    }

    if (isObject(value)) {
      return recursiveReplaceFeaturesSyntaxWithDisplayNames(value, parsedBrackets);
    }

    return value;
  };

  return mapValues(featuresSyntax, (value) => {
    return replaceValue(value);
  });
};
